/** @format */

import React, { FC } from 'react'
import { Table, TableColumn, Pagination } from '@king-design/react'
import { TableProps } from '@king-design/react'
import styled from 'styled-components'
import { omit } from 'lodash'

interface TableSchemeProps extends TableProps {
  scheme: any
  [key: string]: any
}

interface TablePageProps {
  style?: any
  className?: string
  tableProps: TableSchemeProps
  showPage?: boolean
  pageProps?: {
    total: number
    PageIndex?: number
    PageSize?: number
    pageIndex?: number
    pageSize?: number
    onChange?: (value: { value: number; limit: number }) => void
    showLimits?: boolean
    limits?: number[]
    size?: 'large' | 'default' | 'mini' | 'small'
  }
  loading?: boolean
  run?: any
}

const TablePage: FC<TablePageProps> = ({
  style,
  className,
  tableProps,
  showPage = true,
  pageProps,
  loading,
  run
}) => {
  const { scheme } = tableProps || {}
  const {
    total,
    PageIndex,
    PageSize,
    pageIndex,
    pageSize,
    onChange,
    showLimits = true,
    limits,
    size = 'default'
  } = pageProps || {}
  const pageChange = ({ value, limit }) => {
    if (value && limit) {
      if (!loading) {
        run &&
          run(
            PageIndex
              ? {
                  PageIndex: value,
                  PageSize: limit
                }
              : {
                  pageIndex: value,
                  pageSize: limit
                }
          )
      }
    }
  }
  return (
    <div className={className} style={{ ...style }}>
      <Table animation={false} {...tableProps}>
        {scheme && Object.keys(scheme)?.length
          ? Object.keys(scheme).map(key => {
              if (typeof scheme[key] === 'string') {
                return <TableColumn title={scheme[key]} key={key} />
              }
              const { title, template } = scheme[key]
              const filterProps = omit(scheme[key], 'template', 'title')
              if (template) {
                filterProps.slotTemplate = ([data, index]) => template(data, index)
              }
              return <TableColumn key={key} slotTitle={title} {...filterProps} />
            })
          : null}
      </Table>
      {showPage && (
        <Pagination
          total={total || 0}
          value={PageIndex || pageIndex}
          limit={PageSize || pageSize}
          onChange={onChange || pageChange}
          showLimits={showLimits}
          limits={limits}
          size={size}
        />
      )}
    </div>
  )
}

export default styled(TablePage)`
  margin-top: 16px;
  .k-pagination {
    margin-top: 16px;
    text-align: center;
  }
`
